import {
  Badge,
  CalendarToday,
  ContactPhone,
  Email,
  Home,
  Info,
  Person,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Typography
} from '@mui/material';

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_LINK } from '../../common/menu/menuItems/menuList';
import { fetchDoctor } from '../../redux/doctor/doctorAction';
    
const ViewDoctor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  useEffect(() => {
    dispatch(fetchDoctor(id));
  }, [dispatch, id]);
  const doctorState = useSelector((state) => state?.doctor?.fetchDoctor?.data || {});
 
  const handleBack = () => {
    navigate(APP_LINK.LISTDOCTOR);
  };
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  
  const getStatusColor = (status) => {
    switch (status) {
      case 1:
        return 'success';
      case 0:
        return 'error';
      default:
        return 'default';
    }
  };
  
  // Safely extract doctor data
  const doctorData = doctorState?.data || {};
  const userData = doctorData?.User || {};

  
  return (
    <Box sx={{ maxWidth: "100vw", mx: 'auto', p: 2 }}>
      <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={8} lg={9} xl={11}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        Doctor Detail
      </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={3} xl={1} mb={2}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleBack}
                  startIcon={<ArrowBackIcon />}
                >
                  Back
                </Button>
              </Grid>
            </Grid>
      <Card elevation={3}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h5" component="div">
              <Person sx={{ verticalAlign: 'middle', mr: 1 }} />
              Doctor Information
            </Typography>
            <Chip 
              label={userData.status === 1 ? 'Active' : 'Inactive'} 
              color={getStatusColor(userData.status)} 
              icon={<Info />} 
              variant="outlined"
            />
          </Box>
          <Divider sx={{ mb: 3 }} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Person sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Doctor Name
              </Typography>
              <Typography variant="body1" gutterBottom>
                {doctorData.doctor_name || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Email sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Email
              </Typography>
              <Typography variant="body1" gutterBottom>
                {doctorData.email || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <ContactPhone sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Phone Number
              </Typography>
              <Typography variant="body1" gutterBottom>
                {doctorData.phone || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Badge sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Doctor ID
              </Typography>
              <Typography variant="body1" gutterBottom>
                {doctorData.doctor_id || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Person sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Gender
              </Typography>
              <Typography variant="body1" gutterBottom>
                {doctorData.gender_type === 'M' ? 'Male' : 
                 doctorData.gender_type === 'F' ? 'Female' : 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Address
              </Typography>
              <Typography variant="body1" gutterBottom>
                {doctorData.address || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Block
              </Typography>
              <Typography variant="body1" gutterBottom>
                {doctorData?.Block?.block_name || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Floor
              </Typography>
              <Typography variant="body1" gutterBottom>
                {doctorData?.Floor?.floor_name || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Ward
              </Typography>
              <Typography variant="body1" gutterBottom>
                {doctorData?.Ward?.ward_name || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <Home sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Specialization
              </Typography>
              <Typography variant="body1" gutterBottom>
                {doctorData?.Specialization?.Name || 'N/A'}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <CalendarToday sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Created At
              </Typography>
              <Typography variant="body1" gutterBottom>
                {formatDate(doctorData.createdAt)}
              </Typography>
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="text.secondary">
                <CalendarToday sx={{ fontSize: 'small', verticalAlign: 'middle', mr: 1 }} />
                Updated At
              </Typography>
              <Typography variant="body1" gutterBottom>
                {formatDate(doctorData.updatedAt)}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};
    
export default ViewDoctor;